/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ExecuteResolveActionRecommendationsRequest {
    getFixupPrototypeFunction() { return ExecuteResolveActionRecommendationsRequest.fixupPrototype; }

    static newInstance(model: Partial<ExecuteResolveActionRecommendationsRequest>): ExecuteResolveActionRecommendationsRequest {
        let obj = Object.assign(new ExecuteResolveActionRecommendationsRequest(), model);
        ExecuteResolveActionRecommendationsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ExecuteResolveActionRecommendationsRequest>): ExecuteResolveActionRecommendationsRequest {
        if (!model) return null;
        return ExecuteResolveActionRecommendationsRequest.newInstance(<ExecuteResolveActionRecommendationsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ExecuteResolveActionRecommendationsRequest) {
        if (!obj) return;

        models.ExecuteResolveActionRecommendationsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ExecuteResolveActionRecommendationsRequest): boolean {
        Object.setPrototypeOf(obj, ExecuteResolveActionRecommendationsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Action Name to resolve the recommendation
     */
    action_name: string;

    /**
     * Specify the Resource IDs. It will be fetched from list recommendation api
     */
    resources: Array<string>;

}
